<template>
  <div class="jumbotron">
    <div class="row top-row-padding">
      <div class="col">
        <h2>Profiles</h2>
        <div class="row">
          <!--<div class="col-lg-8 offset-lg-2">
            <div class="card" id="businessCard">
              <div class="card-body">
                <div class="homapt-flex-wrapper">
                  <i class="fas fa-building"></i>
                  <h3 class="card-title">Business Owner</h3>
                </div>
                <p class="card-text">Use HomApt to connect with clients, view client offers and guide them through the home buying process.</p>
                <button class="btn btn-primary" v-on:click="toSearch">Create Business Account</button>
              </div>
            </div>
          </div>-->
          <div class="col-lg-8 offset-lg-2">
            <div class="card" id="realtorCard">
              <div class="card-body">
                <div class="homapt-flex-wrapper">
                  <i class="fas fa-home"></i>
                  <h3 class="card-title">Realtor</h3>
                </div>
                <p class="card-text">Use HomApt to connect with clients, view client offers and guide them through the home buying process.</p>
                <button class="btn btn-primary" v-on:click="toRealtorSignUp">Create Realtor Account</button>
              </div>
            </div>
          </div>
          <div class="col-lg-8 offset-lg-2">
            <div class="card" id="businessCard">
              <div class="card-body">
                <div class="homapt-flex-wrapper">
                  <i class="fas fa-tools"></i>
                  <h3 class="card-title">Service Provider</h3>
                </div>
                <p class="card-text">Yarlow helps homeowners find you and get connected, and then keeps you front and center for future work by marking you as their preferred professional.</p>
                <b-button variant="primary" to="/serviceprovidersignup" v-on:click="$global.gaEvent('userProfileServiceProviderCreateClick', 'navigation', 'User used user profile to register as service provider')">Create Service Provider Account</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import router from '../../../../router/index.js'

export default {
  methods: {
    ...mapMutations('user', [
      'updateUserType'
    ]),
    toRealtorSignUp () {
      this.$global.gaEvent('userProfileRealtorCreateClick', 'navigation', 'User used user profile to register as realtor')
      router.replace('/realtorsignup')
    },
    toSearch () {
      router.replace('/claimsearch')
    }
  },
  mounted () {
    this.$global.gaEvent('userProfiles', 'navigation')
  }
}
</script>

<style scoped>
input {
  width: 100%;
}

.form-row-padding {
  padding-bottom: 2rem;
}

.no-margin-bottom {
  margin-bottom: 0px;
}

.homapt-padding-bottom {
  padding-bottom: 2rem;
}

.top-row-padding {
  padding-bottom: 1rem;
}

.grayout {
  background-color: gray !important;
  color: black !important;
  cursor: unset !important;
}

@media (max-width: 768px) {
  .text-right {
    text-align: left !important;
    padding-left: 1rem;
  }
}

.jumbotron {
  background-color: #f1f1f1 !important;
  margin-bottom: 3rem !important;
  border-radius: 25px;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.btn {
  margin-top: 0px !important;
}

.homapt-modal-title {
  color: var(--text-color);
  cursor: pointer;
}

.card {
  margin-top: 2rem;
  margin-bottom: 1rem;
}

.fas {
  font-size: 56px;
  text-align: center;
  text-decoration: none;
}

.homapt-flex-wrapper {
  display: flex;
  padding-bottom: 2rem;
}

.card-title {
  margin-top: auto;
  margin-bottom: auto;
  padding-left: 1rem
}
</style>



// WEBPACK FOOTER //
// src/components/profile/userProfile/profiles/UserProfiles.vue